export default __webpack_public_path__ + "static/media/OverviewGeckoLogo.c918942f.svg";